import { ContactDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/crm/v1/contact_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ContactDeletedDetailProps = {
  event: ContactDeletedEvent;
};

export const ContactDeletedDetail = ({ event }: ContactDeletedDetailProps) => {
  const contact = event.contact;

  if (!contact) {
    return (
      <Col className="@ContactDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@ContactDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Contact
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={contact.id?.value} />
          <FieldDisplay label="Full Name" value={contact.fullName} />
          <FieldDisplay label="Email" value={contact.email} />
          <FieldDisplay label="Phone" value={contact.phone} />
          <FieldDisplay label="Role" value={contact.role} />
          <FieldDisplay label="Department" value={contact.department} />
          <IDField label="Account ID" value={contact.accountId?.value} />
        </div>
      </Col>
    </Col>
  );
};
